import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {SendWelcomeEmailResultModal} from './send-welcome-email.result.modal';
import {
    clearResult,
    selectSendWelcomeEmailBulkUuid,
    selectSendWelcomeEmailShown,
    selectSendWelcomeEmailTask,
} from './send-welcome-email.slice';


export const SendWelcomeEmailResult = () => (
    <BulkActionResult
        actionIdSelector={selectSendWelcomeEmailBulkUuid}
        actionTaskSelector={selectSendWelcomeEmailTask}
        actionShownSelector={selectSendWelcomeEmailShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <SendWelcomeEmailResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
